import PAGE_URLS from '../Constant/pageUrls';
const SearchByPhoneHashCharacteristic = '#searchByPhone';
const BindListHashCharacteristic = '#bindList'

export default () => {
    try {
        /**
         * url中哈希存在#orderlist.list认为是订单列表
         * 另外，由于上游node已经划分好了新老服务的流量，所以到了这里处理结果只有俩种：
         * 1. 新列表，即return不做任何处理
         * 2. #searchByPhone和#bindList两个页面分别跳转到老服务的这两个页面即可
         */

        if(window.location.href.indexOf(SearchByPhoneHashCharacteristic) > -1){
            window.location.href = `${PAGE_URLS.bindList}?businessType=flight%2Ctrain%2Chotel%2Chotel_sight%2Ctese%2Chuiyi%2Cticket%2Clocal%2Cqmall%2Cbus%2Cshopping&source=touch#`
            return false;
        }else if(window.location.href.indexOf(BindListHashCharacteristic) > -1){
            window.location.href = `${PAGE_URLS.searchByPhone}?businessType=flight%2Ctrain%2Cbus%2Chotel%2Chotel_sight%2Ctese%2Chuiyi%2Cticket%2Cfood%2Cicar%2Ccar%2Ctravel%2Clocal%2Cinsure%2Cqmall%2Cshopping%2Cbnb&source=touch#`
            return false;
        }
    } catch (err) {
    }
    return true;
}